import { useState } from "react"
import { useTranslation } from "react-i18next"
import { PencilSimple } from "@phosphor-icons/react"
import { Card, CardHeader, CardHeaderTitle } from "@/components/ui/card"
import { convertLanguageToISOCode } from "@/lib/language-to-iso-code"
import { SteeringLevelDialog } from "@/modules/admin/capacity/components/steering-level-dialog"
import { useSteeringLevelsCapacityQuery } from "@/modules/admin/capacity/services/useSteeringLevelsCapacityQuery"
import { LanguageValues } from "@/types/__generated__/union-types"

const SteeringLevelCard = () => {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const response = useSteeringLevelsCapacityQuery()
  const { steeringLevels } = response

  return (
    <>
      <Card className="h-38.5 w-92.5" data-testid="steering-level-card">
        <CardHeader>
          <div className="flex items-center gap-4">
            <div>
              <CardHeaderTitle data-testid="card-header-title-content">
                {t("admin.capacity.steeringLevel.title")}
              </CardHeaderTitle>
            </div>
          </div>
          <div className="flex justify-end">
            <div
              className="hover:bg-surface-hovered cursor-pointer p-2 hover:rounded-full hover:p-2"
              data-testid="steering-level-edit-button"
              onClick={() => setIsDialogOpen(true)}>
              <PencilSimple className="text-on-surface-subdued" />
            </div>
          </div>
        </CardHeader>
        <div className="text-on-surface-subdued grid items-stretch gap-0 p-4 pt-0 text-sm leading-5 font-normal">
          {[...steeringLevels]
            .sort((a, b) => LanguageValues.indexOf(a.language) - LanguageValues.indexOf(b.language))
            .map((s) => (
              <span key={s.id} data-testid={`steering-level-card-content-${s.language.toLowerCase()}`}>
                {`${convertLanguageToISOCode(s.language)}: ${s.levelValue} - ${t(
                  "admin.capacity.steeringLevel.waitingTime",
                  {
                    waitingTime: `${s.waitingTime.status === "EXCEEDS_MAXIMUM" ? "> " : ""}${s.waitingTime.minutesToWait / 60}`,
                  },
                )}`}
              </span>
            ))}
        </div>
      </Card>
      {isDialogOpen && (
        <SteeringLevelDialog
          steeringLevelData={response}
          onClose={() => {
            setIsDialogOpen(false)
          }}
        />
      )}
    </>
  )
}

export { SteeringLevelCard }
